module.exports = __webpack_public_path__ + "static/NOI6-b5822396469f074bb37161e968bbf503.jpg";